import TextAndImage, { ImageContainer, TextContainer } from './text-and-image'

export default TextAndImage
export {
  ImageContainer,
  TextContainer
}
